 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import BUNDLE_COVER from '@/components/bundle_cover'
 import BUNDLE_TITLE from '@/components/bundle_title'
 import BUNDLE_CONTENT from '@/components/bundle_content'
 import BOOK1V51COVER from '@/components/Book1/v5/1cover'
 import BOOK1V52TITLE_PAGE from '@/components/Book1/v5/2title_page'
 import BOOK1V53TOC from '@/components/Book1/v5/3TOC'
 import BOOK1V54CHAP1 from '@/components/Book1/v5/4chap1'
 import BOOK1V55CHAP2 from '@/components/Book1/v5/5chap2'
 import BOOK1V56CHAP3 from '@/components/Book1/v5/6chap3'
 import BOOK1V57CHAP4 from '@/components/Book1/v5/7chap4'
 import BOOK1V58CHAP5 from '@/components/Book1/v5/8chap5'
 import BOOK1V59CHAP6 from '@/components/Book1/v5/9chap6'
 import BOOK1V510CHAP7 from '@/components/Book1/v5/10chap7'
 import BOOK1V511CHAP8 from '@/components/Book1/v5/11chap8'
 import BOOK1V512CHAP9 from '@/components/Book1/v5/12chap9'
 import BOOK1V513CHAP10 from '@/components/Book1/v5/13chap10'
 import BOOK1V514CHAP11 from '@/components/Book1/v5/14chap11'
 import BOOK1V515CHAP12 from '@/components/Book1/v5/15chap12'
 import BOOK1V516CHAP13 from '@/components/Book1/v5/16chap13'
 import BOOK1V517CHAP14 from '@/components/Book1/v5/17chap14'
 import BOOK1V518CHAP15 from '@/components/Book1/v5/18chap15'
 import BOOK1V519CHAP16 from '@/components/Book1/v5/19chap16'
 import BOOK2V51COVER from '@/components/Book2/v5/1cover'
 import BOOK2V52TITLE_PAGE from '@/components/Book2/v5/2title_page'
 import BOOK2V53TOC from '@/components/Book2/v5/3TOC'
 import BOOK2V54CHAP1 from '@/components/Book2/v5/4chap1'
 import BOOK3V51COVER from '@/components/Book3/v5/1cover'
 import BOOK3V52TITLE_PAGE from '@/components/Book3/v5/2title_page'
 import BOOK3V53DEDICATION from '@/components/Book3/v5/3dedication'
 import BOOK3V5CONTENT from '@/components/Book3/v5/content'
 import BOOK3V54CHAP1 from '@/components/Book3/v5/4chap1'
 import COMONAUTHOR from '@/components/Comon/author'
 import COMONCOPYRIGHT from '@/components/Comon/copyright'
 import COMONBACKAD_1 from '@/components/Comon/backad_1'
 import ORIMAD from '@/components/ORIMad'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/bundle_content",
 			"name" : "bundle_content",
 			"component" : BUNDLE_CONTENT
 		},
 		{
 			"path" : "/Book1/v5/1cover",
 			"name" : "Book1/v5/1cover",
 			"component" : BOOK1V51COVER
 		},
 		{
 			"path" : "/Book1/v5/2title_page",
 			"name" : "Book1/v5/2title_page",
 			"component" : BOOK1V52TITLE_PAGE
 		},
 		{
 			"path" : "/Book1/v5/3TOC",
 			"name" : "Book1/v5/3TOC",
 			"component" : BOOK1V53TOC
 		},
 		{
 			"path" : "/Book1/v5/4chap1",
 			"name" : "Book1/v5/4chap1",
 			"component" : BOOK1V54CHAP1
 		},
 		{
 			"path" : "/Book1/v5/5chap2",
 			"name" : "Book1/v5/5chap2",
 			"component" : BOOK1V55CHAP2
 		},
 		{
 			"path" : "/Book1/v5/6chap3",
 			"name" : "Book1/v5/6chap3",
 			"component" : BOOK1V56CHAP3
 		},
 		{
 			"path" : "/Book1/v5/7chap4",
 			"name" : "Book1/v5/7chap4",
 			"component" : BOOK1V57CHAP4
 		},
 		{
 			"path" : "/Book1/v5/8chap5",
 			"name" : "Book1/v5/8chap5",
 			"component" : BOOK1V58CHAP5
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js